import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ element: Component, permissions, ...rest }) => {
  const location = useLocation();
  const path = location.pathname;
  const hasPermission = permissions.some((perm) => {
    if (Array.isArray(perm.route)) {
      // console.warn("Perm: ", perm.route);
      return perm.route.some(
        (item) => item.route.replace(/ /g, "") === path.replace(/ /g, "")
      );
    } else {
      return perm.route === path;
    }
  });

  return hasPermission ? (
    <Component {...rest} />
  ) : (
    <Navigate to="/not-authorized" />
    // <Navigate to={location} />
  );
};

export default ProtectedRoute;
